import { Block as e } from "../../components/FocusBlock.es.js";
import { jsx as t } from "react/jsx-runtime";
// lib/Image/components/Figure.tsx
var n = ({ children: n, editor: r, element: i, options: a }) => {
	let o = a?.removable ?? !1;
	return /* @__PURE__ */ t(e, {
		editor: r,
		element: i,
		removable: o,
		children: /* @__PURE__ */ t("figure", {
			className: "flex gap-1 flex-col min-h-10 rounded-sm",
			children: n
		})
	});
};
export { n as Figure };
